<template>
  <div class="emoji-canvas" ref="emojiCanvas">
    <div v-if="loaded">
      <EmojiEntity v-for="emojiLocation in emojiMap" :key="emojiMap.id" :emoji-location="emojiLocation" :container="$refs['emojiCanvas']"/>
    </div>
  </div>
</template>

<script>
import EmojiEntity from "./EmojiEntity";

export default {
  name: 'EmojiCanvas',
  components: {EmojiEntity},

  data() {
    return {
      loaded: false
    }
  },

  mounted() {
      this.loaded = true
  },

  computed: {
    emojiMap() {
      return this.$store.getters.emojiMap
    }
  },
}
</script>